<template>
  <div class="tw-grid service-header-chips">
    <div class="tw-flex tw-items-center tw-text-infinity-secondary-text tw-self-start tw-pt-1.5">
      <font-awesome-icon class="tw-mr-1.5 tw-text-infinity-tertiary-text" :icon="icon"/>
      <div>{{label}}:</div>
    </div>
    <div class="tw-flex tw-flex-wrap">
      <BaseChip class="tw-m-1 tw-text-infinity-primary-text tw-border-infinity-primary-text" v-for="(chip, index) in groupedChips.shown" :label="chip.name" :key="chip.id" />
      <BaseChip class="tw-m-1 tw-bg-infinity-primary-text tw-border-infinity-primary-text tw-text-infinity-background tw-cursor-pointer" @click="showAll = true" v-if="groupedChips.hidden.length" :label="`+${groupedChips.hidden.length} More`" />
    </div>
  </div>
</template>
<script>
import BaseChip from "../../base/base-chip";

export default {
  components: { BaseChip },
  props: {
    icon: {
      required: true
    },
    label: {
      type: String,
      required: true
    },
    chips: {
      type: Array,
      required: true
    },
    maxWeight: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      showAll: false
    }
  },
  computed: {
    groupedChips() {
      return this.chips.map((chip) => ({
        ...chip,
        weight: this.getChipWeight(chip)
      })).reduce((result, chip) => {
        if (this.showAll) {
          result.shown.push(chip)
          return result
        }
        result.currentWeight += chip.weight
        if (result.currentWeight <= this.maxWeight) {
          result.shown.push(chip)
        } else {
          result.hidden.push(chip)
        }
        return result
      }, { currentWeight: 0, shown: [], hidden: [] })
    }
  },
  methods: {
    getChipWeight(chip) {
      const maxLength = 13
      return Math.ceil(chip.name.length / maxLength)
    },
  }
}
</script>
<style lang="scss" scoped>
.service-header-chips {
  @apply tw-gap-2;
  grid-template-columns: 1fr;

  @screen sm {
    grid-template-columns: 140px 1fr;
  }
}
</style>
